import { postData } from "./Api";

export const getChatUserList = async (searchText = "", pageNumber = 1) => {
  let data = localStorage.getItem("loginDetails");
  let adminToken = JSON.parse(data).token;

  let headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${adminToken}`,
  };

  let body = {
    search_text: searchText,
    page_number: pageNumber,
    limit: 10,
  };

  let response = await postData("user-chat-list", body, headers);
  return response;
};

export const getUserChat = async (id, pageNumber) => {
  let data = localStorage.getItem("loginDetails");
  let adminToken = JSON.parse(data).token;

  let headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${adminToken}`,
  };

  let body = {
    receiver_user_id: id,
    page_number: pageNumber,
    limit: 50,
  };

  let response = await postData("messages", body, headers);
  return response;
};

export const updateUnreadMessage = async (id) => {
  let data = localStorage.getItem("loginDetails");
  let adminToken = JSON.parse(data).token;

  let headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${adminToken}`,
  };

  let body = {
    user_id: id
  };

  let response = await postData("read-messages", body, headers);
  return response;
};

export const sendingMessageOld = async (id, message) => {
  let data = localStorage.getItem("loginDetails");
  let adminToken = JSON.parse(data).token;

  let headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${adminToken}`,
  };

  let body = {
    receiver_id: id,
    message: message,
  };

  let response = await postData("send-message", body, headers);
  return response;
};

export const sendingMessage = async (formData) => {
  try {
    let data = localStorage.getItem("loginDetails");
    let adminToken = JSON.parse(data).token;

    let headers = {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${adminToken}`,
    };

    let response = await postData("send-message", formData, headers);
    return response;
  } catch (error) {
    console.error('Error in uploadChatFile:', error);
    throw error; // Rethrow the error to be handled by the caller
  }
};